import { Route, Routes } from 'react-router-dom';
import { useDispatch, useSelector } from "react-redux";
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import Orders from './orders';
import OrderDetails from './orderDetails';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';
import LogoutIcon from '@mui/icons-material/Logout';
import { handleChangeDataModalLogOutCourier } from '../../../../../redux/actions/partials/modals/modalLogOutCourier';


const Profile = () => {

	const dispatch = useDispatch();
	
	const { courierProfile } = useSelector(state => state.courierLogin);

	const showLogOutModal = () => {
		dispatch(handleChangeDataModalLogOutCourier('isOpen', true));
		setTimeout(() => dispatch(handleChangeDataModalLogOutCourier('isActive', true)), 0);
	};

    return (

    	<div className="grow bg-neutral-000 flex flex-col w-full items-center shrink-0" style={{paddingTop: '168px', paddingLeft: '0px', paddingBottom: '0px'}}>
	    	<div className="grow bg-neutral-000 container-xl-w flex flex-col items-center w-full pt-6 px-6">
				<div className="relative flex flex-col lg:grid grid-cols-1 lg:grid-cols-7 gap-4 gap-y-0 mt-0  pt-4 pb-6 lg:px-4 w-full">
					<div className="lg:col-span-2">
						<div className="sticky-outer-wrapper z-1">
							<div className="sticky-inner-wrapper" style={{position: 'relative', top: '0px'}}>
								<div>
									<div className="lg:bg-neutral-000 w-full lg:border-complete-200 lg:rounded-medium overflow-hidden">
										<div className="mx-5 lg:mx-4 lg:py-4 bg-neutral-000 lg:border-complete-b">
											<div className="flex justify-between items-center mb-2 pb-5 lg:pb-0 styles-ProfileSidebarUserCard-info">
												<div className="flex flex-col">
													<p className="text-h5 text-neutral-800">
														{courierProfile.fname} {courierProfile.lname}
													</p>
													<p className="text-body-1 text-neutral-400 styles-ProfileSidebarUserCard-userPhone">
														{courierProfile.mobile}
													</p>
												</div>
											</div>
										</div>
										<div className="bg-neutral-000 flex-col lg:pb-2">
											<div className="relative px-5">
												<Link to={`orders`} className="py-3 break-words block border-complete-t">
													<div className="flex justify-between items-center">
														<div className="flex flex-shrink-0 ml-4">
															<AssignmentIcon style={{fontSize: '24px', fill: 'black'}} />
														</div>
														<div className="grow text-left">
															<span className="grow text-neutral-700 text-body1-strong">سفارش ها</span>
															<div></div>
														</div>
													</div>
												</Link>
											</div>
											<div className="relative px-5">
												<Link onClick={showLogOutModal} className="py-3 break-words block border-complete-t">
													<div className="flex justify-between items-center">
														<div className="flex flex-shrink-0 ml-4">
															<LogoutIcon style={{fontSize: '24px', fill: 'black'}} />
														</div>
														<div className="grow text-left">
															<span className="grow text-neutral-700 text-body1-strong">خروج</span>
															<div></div>
														</div>
													</div>
												</Link>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="lg:col-span-5">
						<div>
							<Routes> 
			                    <Route path='/orders' element={<Orders />} />
			                    <Route path='/orders/:uniqueCode' element={<OrderDetails />} />
			                </Routes>
						</div>
					</div>
				</div>
			</div>
		</div>

    );
}

export default Profile;